import { UserDto } from "../../../screens/options-table/types/UserDto";
import { createAuthenticatedApiClient } from "./AuthenticatedApiClient";

type ApiClient = ReturnType<typeof createAuthenticatedApiClient>;

export function createUserApi(apiClient: ApiClient) {
    const getCurrent = async (): Promise<UserDto | null> => {
        try {
            const response = await apiClient.get<UserDto>("api/users/current");
            return response?.data ?? null;
        } catch (error: any) {
            console.log(error);
            return null;
        }
    };

    return {
        getCurrent,
    };
}
